<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <ChemicalActiveIngredients />
    </div>
</template>

<script>
import currentUserQuery from '@views/ChemicalActiveIngredients/Browse/queryCurrentUser.graphql';

import ChemicalActiveIngredients from '../ChemicalActiveIngredients/Browse.vue';

export default {
  name: 'ChemicalActiveIngredientsContainer',
  components: {
    ChemicalActiveIngredients,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['association', 'developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
